var map = {
	"./Img-01.jpg": 573,
	"./Img-02.jpg": 574,
	"./Img-03.jpg": 575,
	"./Img-05.jpg": 576,
	"./Img-07.jpg": 577,
	"./K.png": 578,
	"./b.png": 579,
	"./blog-grid/author_img.png": 224,
	"./blog-grid/blog_list1.jpg": 580,
	"./blog-grid/blog_list2.jpg": 581,
	"./blog-grid/blog_list3.jpg": 582,
	"./blog-grid/blog_list4.jpg": 583,
	"./blog-grid/blog_single.png": 225,
	"./blog-grid/comment1.png": 226,
	"./blog-grid/comment2.png": 227,
	"./blog-grid/post_1.jpg": 584,
	"./blog-grid/post_2.jpg": 585,
	"./blog-grid/post_3.jpg": 586,
	"./blog-grid/post_4.jpg": 587,
	"./blog-grid/post_img_1.png": 228,
	"./blog-grid/post_img_2.png": 229,
	"./blog-grid/post_img_3.png": 230,
	"./br_logo.png": 588,
	"./breadcrumb/banner_bg.png": 589,
	"./breadcrumb/service.png": 590,
	"./breadcrumb/service_details.png": 591,
	"./breadcrumb/service_details_one.png": 592,
	"./cart1.jpg": 593,
	"./cart2.jpg": 594,
	"./erp-home/action_img.png": 86,
	"./erp-home/background.png": 231,
	"./erp-home/banner_shap.png": 232,
	"./erp-home/bulb.png": 233,
	"./erp-home/cloud-computing.png": 234,
	"./erp-home/cloud.png": 235,
	"./erp-home/cloud_01.png": 87,
	"./erp-home/cloud_02.png": 88,
	"./erp-home/cloud_03.png": 89,
	"./erp-home/cloud_04.png": 90,
	"./erp-home/cloud_05.png": 91,
	"./erp-home/cloud_06.png": 92,
	"./erp-home/cloud_blue.png": 236,
	"./erp-home/crm_img1.jpg": 237,
	"./erp-home/crm_img2.jpg": 238,
	"./erp-home/crm_img3.jpg": 239,
	"./erp-home/erp_dashboard.jpg": 93,
	"./erp-home/erp_icon1.png": 240,
	"./erp-home/erp_icon2.png": 241,
	"./erp-home/erp_icon3.png": 242,
	"./erp-home/erp_icon4.png": 243,
	"./erp-home/erp_icon5.png": 244,
	"./erp-home/erp_icon6.png": 245,
	"./erp-home/growth.png": 246,
	"./erp-home/img/01.png": 94,
	"./erp-home/img/02.png": 95,
	"./erp-home/img/03.png": 96,
	"./erp-home/img/04.png": 97,
	"./erp-home/img/05.png": 98,
	"./erp-home/img/06.png": 99,
	"./erp-home/img/07.png": 100,
	"./erp-home/img/08.png": 101,
	"./erp-home/img/09.png": 102,
	"./erp-home/img/10.png": 103,
	"./erp-home/img/11.png": 104,
	"./erp-home/img/12.png": 105,
	"./erp-home/img/13.png": 106,
	"./erp-home/img/14.png": 107,
	"./erp-home/img/15.png": 108,
	"./erp-home/img/16.png": 109,
	"./erp-home/img/17.png": 110,
	"./erp-home/img/18.png": 111,
	"./erp-home/img/19.png": 112,
	"./erp-home/img/20.png": 113,
	"./erp-home/quote.png": 247,
	"./erp-home/rocket.png": 114,
	"./erp-home/settings.png": 248,
	"./erp-home/settings1.png": 249,
	"./erp-home/shape.png": 250,
	"./erp-home/software_development.png": 251,
	"./erp-home/team.png": 252,
	"./erp-home/testimonial_img.jpg": 253,
	"./erp-home/testimonial_img2.jpg": 254,
	"./erp-home/website.png": 255,
	"./error_bg.png": 595,
	"./favicon.png": 596,
	"./home-security/about_img_1.jpg": 256,
	"./home-security/about_img_2.jpg": 257,
	"./home-security/apple_icon.png": 115,
	"./home-security/banner.png": 116,
	"./home-security/leaf_clients1.png": 117,
	"./home-security/leaf_clients2.png": 118,
	"./home-security/mackbook.png": 119,
	"./home-security/padlock.png": 120,
	"./home-security/real-estate.png": 258,
	"./home-security/rocket.png": 259,
	"./home-security/security_1.png": 260,
	"./home-security/security_2.png": 261,
	"./home-security/security_3.png": 262,
	"./home-security/security_4.png": 263,
	"./home-security/shap.png": 121,
	"./home-security/sheld_bg.png": 122,
	"./home-security/shield.png": 123,
	"./home-security/windows_icon.png": 124,
	"./home-software/analytices1.png": 597,
	"./home-software/analytices2.png": 598,
	"./home-software/analytices3.png": 599,
	"./home-software/analytices4.png": 600,
	"./home-software/analytices5.jpg": 601,
	"./home-software/analytices6.jpg": 602,
	"./home-software/analytices7.jpg": 603,
	"./home-software/analytices8.jpg": 604,
	"./home-software/case.png": 605,
	"./home-software/down_bg.png": 606,
	"./home-software/elements_five.png": 607,
	"./home-software/elements_four.png": 608,
	"./home-software/elements_one.png": 609,
	"./home-software/elements_six.png": 610,
	"./home-software/elements_three.png": 611,
	"./home-software/elements_two.png": 612,
	"./home-software/line_02.png": 613,
	"./home-software/logo_01.png": 264,
	"./home-software/logo_02.png": 265,
	"./home-software/logo_03.png": 266,
	"./home-software/logo_04.png": 267,
	"./home-software/logo_05.png": 268,
	"./home-software/logo_06.png": 40,
	"./home-software/logo_07.png": 41,
	"./home-software/logo_08.png": 42,
	"./home-software/logo_09.png": 614,
	"./home-software/logo_10.png": 615,
	"./home-software/logo_11.png": 616,
	"./home-software/logo_12.png": 617,
	"./home-software/mackbook.png": 618,
	"./home-software/pie.png": 619,
	"./home-software/setup_img1.png": 620,
	"./home-software/setup_img2.png": 621,
	"./home-software/setup_img3.png": 622,
	"./home-software/shap_3.png": 623,
	"./home-software/shap_one.png": 624,
	"./home-software/shap_two.png": 625,
	"./home2/action_bg.png": 626,
	"./home2/file.png": 125,
	"./home2/inbox.png": 126,
	"./home2/report.png": 127,
	"./home2/undraw.png": 128,
	"./home3/action_image.png": 269,
	"./home3/dimond.png": 270,
	"./home3/logo_01.png": 58,
	"./home3/logo_02.png": 129,
	"./home3/logo_03.png": 130,
	"./home3/logo_04.png": 59,
	"./home3/logo_05.png": 60,
	"./home3/p_feature1.png": 271,
	"./home3/prototype_banner_img.png": 272,
	"./home3/prototype_banner_img2.png": 273,
	"./home3/psd.png": 274,
	"./home3/saas.png": 275,
	"./home3/tab.png": 276,
	"./home4/action_shap.png": 277,
	"./home4/author_img.png": 278,
	"./home4/banner_bg.png": 131,
	"./home4/banner_img.png": 132,
	"./home4/divider.png": 133,
	"./home4/dot.png": 134,
	"./home4/icon01.png": 279,
	"./home4/icon02.png": 280,
	"./home4/icon3.png": 281,
	"./home4/icon_04.png": 282,
	"./home4/icon_05.png": 283,
	"./home4/icon_shape1.png": 284,
	"./home4/icon_shape2.png": 285,
	"./home4/icon_shape3.png": 286,
	"./home4/icon_shape4.png": 287,
	"./home4/process_1.png": 288,
	"./home4/process_2.png": 289,
	"./home4/process_3.png": 290,
	"./home4/process_4.png": 291,
	"./home4/process_5.png": 292,
	"./home4/shape.png": 293,
	"./home4/team1.jpg": 61,
	"./home4/team2.jpg": 31,
	"./home4/work1.png": 294,
	"./home4/work2.png": 295,
	"./home4/work3.png": 296,
	"./home5/01.jpg": 627,
	"./home5/02.jpg": 628,
	"./home5/03.jpg": 629,
	"./home5/banner_img.png": 630,
	"./home5/design1.png": 631,
	"./home5/design2.png": 632,
	"./home5/featured_bg_shape.png": 633,
	"./home5/featured_img1.png": 634,
	"./home5/icon1.png": 635,
	"./home5/icon2.png": 636,
	"./home5/icon3.png": 637,
	"./home5/icon_shape.png": 638,
	"./home5/php.jpg": 639,
	"./home5/shap_tecture.png": 640,
	"./home7/01.png": 297,
	"./home7/02.png": 298,
	"./home7/03.png": 299,
	"./home7/app.png": 300,
	"./home7/banner.png": 641,
	"./home7/google_icon.png": 301,
	"./home7/iPhoneX2.png": 302,
	"./home7/iPhonex.png": 303,
	"./home7/screenshot1.png": 62,
	"./home7/screenshot2.png": 304,
	"./home7/screenshot3.png": 135,
	"./home7/screenshot4.png": 305,
	"./home7/screenshot5.png": 306,
	"./home7/team_01.jpg": 642,
	"./home7/team_02.jpg": 643,
	"./home7/team_03.jpg": 644,
	"./home7/team_04.jpg": 645,
	"./home7/testimonial_author_img.png": 63,
	"./home7/text_one.png": 307,
	"./home7/text_three.png": 308,
	"./home7/text_two.png": 309,
	"./home8/banner_img.png": 310,
	"./home8/dot.png": 646,
	"./home8/fact.png": 647,
	"./home8/service_item_03.png": 648,
	"./home9/featured_img.png": 136,
	"./home9/featured_img_two.png": 137,
	"./home9/flag.png": 311,
	"./home9/footer.png": 312,
	"./home9/icon1.png": 138,
	"./home9/icon2.png": 43,
	"./home9/icon3.png": 139,
	"./home9/icon4.png": 313,
	"./home9/icon5.png": 314,
	"./home9/icon6.png": 315,
	"./home9/icon7.png": 316,
	"./home9/icon8.png": 317,
	"./home9/icon_shape.png": 44,
	"./home9/icon_shape_two.png": 318,
	"./home9/logo1.png": 140,
	"./home9/logo2.png": 141,
	"./home9/logo3.png": 142,
	"./home9/logo4.png": 143,
	"./home9/logo5.png": 144,
	"./home9/logo6.png": 145,
	"./home9/logo7.png": 146,
	"./home9/logo8.png": 147,
	"./home9/mac.png": 148,
	"./home9/map.png": 319,
	"./home9/shape-footer.png": 320,
	"./home9/shape.png": 149,
	"./home9/shape_two.png": 321,
	"./home9/testimonial_img.png": 150,
	"./home9/testimonial_img2.png": 322,
	"./home9/triangle_bottom.png": 323,
	"./home9/triangle_top.png": 324,
	"./hosting/action_img.png": 325,
	"./hosting/business1.png": 326,
	"./hosting/business2.png": 327,
	"./hosting/h_blog1.jpg": 328,
	"./hosting/h_blog2.jpg": 329,
	"./hosting/hosting-image.png": 151,
	"./hosting/hosting_action_bg.png": 152,
	"./hosting/icon1.png": 330,
	"./hosting/icon10.png": 331,
	"./hosting/icon2.png": 332,
	"./hosting/icon3.png": 333,
	"./hosting/icon4.png": 334,
	"./hosting/icon5.png": 335,
	"./hosting/icon6.png": 336,
	"./hosting/icon7.png": 337,
	"./hosting/icon8.png": 338,
	"./hosting/icon9.png": 339,
	"./hosting/line_01.png": 153,
	"./hosting/line_02.png": 154,
	"./hosting/line_03.png": 155,
	"./hosting/line_04.png": 156,
	"./hosting/line_05.png": 157,
	"./hosting/line_06.png": 158,
	"./hosting/line_07.png": 159,
	"./hosting/line_08.png": 160,
	"./hosting/map.png": 340,
	"./hosting/region_map.png": 341,
	"./jarvix-logo-white.svg": 342,
	"./jarvix-logo.svg": 209,
	"./login_img.png": 649,
	"./login_img2.png": 650,
	"./logo-3-2x.png": 651,
	"./logo-horizontal-white2.svg": 652,
	"./logo-horizontal2.svg": 653,
	"./logo-sticky-2x.png": 654,
	"./logo-sticky.png": 655,
	"./logo-sticky2.png": 656,
	"./logo-sticky3.png": 657,
	"./logo-sticky4.png": 658,
	"./logo.png": 45,
	"./logo.svg": 659,
	"./logo2.png": 64,
	"./logo2x-2.png": 660,
	"./logo2x.png": 661,
	"./logo3.png": 343,
	"./logo4.png": 662,
	"./logo7.png": 663,
	"./logo8.png": 664,
	"./mega-menu-img/Prototyping_Tool.jpg": 344,
	"./mega-menu-img/analytices.jpg": 665,
	"./mega-menu-img/coming_img.jpg": 666,
	"./mega-menu-img/erp.jpg": 345,
	"./mega-menu-img/home-animation.jpg": 667,
	"./mega-menu-img/home-chat.jpg": 668,
	"./mega-menu-img/home-event.jpg": 669,
	"./mega-menu-img/home-security.jpg": 346,
	"./mega-menu-img/home-track.jpg": 670,
	"./mega-menu-img/home1.jpg": 671,
	"./mega-menu-img/home10.jpg": 672,
	"./mega-menu-img/home11.jpg": 347,
	"./mega-menu-img/home12.jpg": 673,
	"./mega-menu-img/home13.jpg": 674,
	"./mega-menu-img/home14.jpg": 348,
	"./mega-menu-img/home15.jpg": 349,
	"./mega-menu-img/home16.jpg": 350,
	"./mega-menu-img/home17.jpg": 675,
	"./mega-menu-img/home2.jpg": 676,
	"./mega-menu-img/home3.jpg": 351,
	"./mega-menu-img/home4.jpg": 352,
	"./mega-menu-img/home5.jpg": 677,
	"./mega-menu-img/home6.jpg": 678,
	"./mega-menu-img/home7.jpg": 679,
	"./mega-menu-img/home8.jpg": 680,
	"./mega-menu-img/home9.jpg": 681,
	"./mega-menu-img/hosting.jpg": 353,
	"./mega-menu-img/icon/app-d.png": 682,
	"./mega-menu-img/icon/blup.png": 683,
	"./mega-menu-img/pos.jpg": 684,
	"./mega-menu-img/saas2-slider.png": 685,
	"./mega-menu-img/support.jpg": 354,
	"./new-home/back_bg.png": 355,
	"./new-home/banner.png": 161,
	"./new-home/briteverify.png": 162,
	"./new-home/campfire.png": 163,
	"./new-home/email.png": 164,
	"./new-home/kissmetrics.png": 165,
	"./new-home/metorik.png": 166,
	"./new-home/nicereply-1.png": 167,
	"./new-home/p-1.png": 168,
	"./new-home/p-2.png": 169,
	"./new-home/p-3.png": 170,
	"./new-home/tab.png": 171,
	"./new-home/tab_2.png": 172,
	"./new-home/tab_3.png": 173,
	"./new-home/ticket-support.png": 174,
	"./new-home/tree-left.png": 175,
	"./new-home/tree-right.png": 176,
	"./new-home/tree.png": 177,
	"./new-home/update.png": 178,
	"./new-home/webhooks.png": 179,
	"./new-home/wedsite.png": 180,
	"./new/01.png": 686,
	"./new/0111.png": 356,
	"./new/02.png": 687,
	"./new/0222.png": 357,
	"./new/03.png": 688,
	"./new/04.png": 689,
	"./new/05.png": 690,
	"./new/06.png": 691,
	"./new/app_screen.png": 692,
	"./new/blog/blog_grid_1.jpg": 358,
	"./new/blog/blog_grid_2.jpg": 359,
	"./new/blog/blog_grid_3.jpg": 360,
	"./new/blog/blog_grid_4.jpg": 361,
	"./new/blog/blog_grid_5.jpg": 362,
	"./new/blog/blog_grid_6.jpg": 363,
	"./new/blog/blog_grid_7.jpg": 364,
	"./new/blog/blog_grid_8.jpg": 365,
	"./new/case/case_01.jpg": 693,
	"./new/case/case_02.jpg": 694,
	"./new/case/case_03.jpg": 695,
	"./new/case/case_04.jpg": 696,
	"./new/case/case_05.jpg": 697,
	"./new/case/case_06.jpg": 698,
	"./new/case/case_07.jpg": 699,
	"./new/case/case_08.jpg": 700,
	"./new/case/case_09.jpg": 701,
	"./new/case/case_10.jpg": 702,
	"./new/case/case_11.jpg": 703,
	"./new/case/case_12.jpg": 704,
	"./new/case/case_details_01.jpg": 705,
	"./new/case/case_details_02.jpg": 706,
	"./new/case/case_details_03.jpg": 707,
	"./new/case/parallax.png": 708,
	"./new/coming_soon_bg.png": 709,
	"./new/company.jpg": 710,
	"./new/cup.png": 366,
	"./new/digital_img.png": 711,
	"./new/error.png": 712,
	"./new/features_01.png": 713,
	"./new/feedback_shap.png": 714,
	"./new/home-split/contact.png": 715,
	"./new/iPhoneX.png": 26,
	"./new/icon.png": 716,
	"./new/icon/icon1.png": 717,
	"./new/icon/icon2.png": 718,
	"./new/icon2.png": 719,
	"./new/icon3.png": 720,
	"./new/intregration_1.png": 367,
	"./new/intregration_2.png": 368,
	"./new/intregration_3.png": 369,
	"./new/intregration_4.png": 370,
	"./new/laptop.png": 371,
	"./new/laptop_two.png": 721,
	"./new/leaf.png": 372,
	"./new/line_01.png": 373,
	"./new/line_02.png": 374,
	"./new/line_03.png": 375,
	"./new/logo_01.png": 722,
	"./new/logo_02.png": 723,
	"./new/logo_03.png": 724,
	"./new/logo_04.png": 725,
	"./new/logo_05.png": 726,
	"./new/member_01.jpg": 727,
	"./new/new_shape.png": 728,
	"./new/phone.png": 376,
	"./new/price_bg.png": 729,
	"./new/shape_bg.png": 730,
	"./new/solution_01.jpg": 731,
	"./new/solution_02.jpg": 732,
	"./new/startup_banner_bg.png": 733,
	"./new/startup_banner_img.png": 377,
	"./new/startup_shap.png": 734,
	"./new/tab_shape_bg.png": 735,
	"./new/testimonial_bg.png": 736,
	"./new/testimonial_bg_shap.png": 737,
	"./new/testimonial_bg_two.png": 738,
	"./new/video_bg.jpg": 739,
	"./new/video_img_01.png": 740,
	"./new/video_img_02.jpg": 741,
	"./new/web_image.jpg": 27,
	"./new_logo.png": 742,
	"./portfolio-details/pr_details1.jpg": 378,
	"./portfolio-details/pr_details2.jpg": 379,
	"./portfolio-details/pr_details3.jpg": 380,
	"./portfolio-details/pr_details4.jpg": 381,
	"./portfolio/2-columns/grid1.jpg": 382,
	"./portfolio/2-columns/grid2.jpg": 383,
	"./portfolio/2-columns/grid3.jpg": 384,
	"./portfolio/2-columns/grid4.jpg": 385,
	"./portfolio/2-columns/grid5.jpg": 386,
	"./portfolio/2-columns/grid6.jpg": 387,
	"./portfolio/2-columns/grid7.jpg": 388,
	"./portfolio/2-columns/grid8.jpg": 389,
	"./portfolio/3-columns/3_col_1.jpg": 390,
	"./portfolio/3-columns/3_col_10.jpg": 391,
	"./portfolio/3-columns/3_col_11.jpg": 392,
	"./portfolio/3-columns/3_col_12.jpg": 393,
	"./portfolio/3-columns/3_col_2.jpg": 394,
	"./portfolio/3-columns/3_col_3.jpg": 395,
	"./portfolio/3-columns/3_col_4.jpg": 396,
	"./portfolio/3-columns/3_col_5.jpg": 397,
	"./portfolio/3-columns/3_col_6.jpg": 398,
	"./portfolio/3-columns/3_col_7.jpg": 399,
	"./portfolio/3-columns/3_col_8.jpg": 400,
	"./portfolio/3-columns/3_col_9.jpg": 401,
	"./portfolio/full-width/full_1.jpg": 402,
	"./portfolio/full-width/full_10.jpg": 403,
	"./portfolio/full-width/full_11.jpg": 404,
	"./portfolio/full-width/full_12.jpg": 405,
	"./portfolio/full-width/full_2.jpg": 406,
	"./portfolio/full-width/full_3.jpg": 407,
	"./portfolio/full-width/full_4.jpg": 408,
	"./portfolio/full-width/full_5.jpg": 409,
	"./portfolio/full-width/full_6.jpg": 410,
	"./portfolio/full-width/full_7.jpg": 411,
	"./portfolio/full-width/full_8.jpg": 412,
	"./portfolio/full-width/full_9.jpg": 413,
	"./pos/High-end-all-in-one-dual-screen.png": 743,
	"./pos/b_dashboard.png": 744,
	"./pos/cash-register.png": 745,
	"./pos/chat.png": 746,
	"./pos/credit-card.png": 747,
	"./pos/delivery-truck.png": 748,
	"./pos/ezgif-1-997e5035cba4.png": 749,
	"./pos/fotter_shap.png": 750,
	"./pos/icon1.png": 751,
	"./pos/icon2.png": 752,
	"./pos/icon3.png": 753,
	"./pos/item1.png": 754,
	"./pos/item2.png": 755,
	"./pos/item3.png": 756,
	"./pos/laptop.png": 757,
	"./pos/leaf-left.png": 414,
	"./pos/leaf-right.png": 415,
	"./pos/mailbox.png": 758,
	"./pos/man.png": 416,
	"./pos/pattern_01.png": 759,
	"./pos/pattern_02.png": 760,
	"./pos/people.png": 417,
	"./pos/pos.png": 761,
	"./pos/pos_about_img.png": 762,
	"./pos/pos_blog_1.png": 763,
	"./pos/pos_blog_2.png": 764,
	"./pos/pos_blog_3.png": 765,
	"./pos/pos_slideshow1.jpg": 766,
	"./pos/pos_slideshow2.jpg": 767,
	"./pos/pos_slideshow3.jpg": 768,
	"./pos/shape.png": 769,
	"./pos/shape_bg.png": 770,
	"./pos/statistics.png": 771,
	"./pos/tab_pattern.png": 772,
	"./pos/wave_two.png": 773,
	"./pos/women.png": 418,
	"./price/one.png": 774,
	"./price/three.png": 775,
	"./price/two.png": 776,
	"./process/ASAN-logo-icon.png": 777,
	"./process/Avast_Antivirus.png": 778,
	"./process/UTorrent_(logo).png": 779,
	"./process/btFMmsoh.png": 780,
	"./process/logo-slack.png": 781,
	"./process/png-logo-design.png": 782,
	"./qoute.png": 783,
	"./saas/map.png": 784,
	"./seo/bike.png": 785,
	"./seo/car.png": 786,
	"./seo/cloud.png": 419,
	"./seo/cloud_bg.png": 787,
	"./seo/features_img.png": 217,
	"./seo/features_img_two.png": 220,
	"./seo/footer_bg.png": 788,
	"./seo/icon1.png": 214,
	"./seo/icon2.png": 215,
	"./seo/icon3.png": 219,
	"./seo/icon4.png": 218,
	"./seo/icon5.png": 216,
	"./seo/image.png": 213,
	"./seo/logo_01.png": 420,
	"./seo/logo_02.png": 421,
	"./seo/logo_03.png": 422,
	"./seo/logo_04.png": 423,
	"./seo/logo_05.png": 424,
	"./seo/logo_06.png": 425,
	"./seo/logo_07.png": 426,
	"./seo/logo_08.png": 427,
	"./seo/logo_09.png": 428,
	"./seo/shap.png": 789,
	"./seo/studies_img_one.jpg": 222,
	"./seo/studies_img_three.jpg": 85,
	"./seo/studies_img_two.jpg": 223,
	"./seo/triangle_one.png": 210,
	"./seo/triangle_three.png": 212,
	"./seo/triangle_two.png": 211,
	"./svg.svg": 790,
	"./teams/team_01.jpg": 429,
	"./teams/team_02.jpg": 430,
	"./teams/team_03.jpg": 431,
	"./teams/team_04.jpg": 432,
	"./teams/team_10.jpg": 433,
	"./teams/team_12.jpg": 434,
	"./teams/team_5.jpg": 435,
	"./teams/team_6.jpg": 436,
	"./teams/team_7.jpg": 437,
	"./teams/team_8.jpg": 438,
	"./teams/team_9.jpg": 439,
	"./technologies/icons8-spring-logo-48.png": 440,
	"./technologies/java.png": 441,
	"./technologies/kafka.png": 442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39;